export const SuperEditorContentId = 'super-editor-content';
